export const FETCH_SUPPORT_TICKET = "FETCH_SUPPORT_TICKET";
export const FETCH_SUPPORT_TICKET_SUCESS = "FETCH_SUPPORT_TICKET_SUCESS"
export const FETCH_SUPPORT_TICKET_ERROR = "FETCH_SUPPORT_TICKET_ERROR"